import styled from 'styled-components';
import SelectHour from './component';

export default styled(SelectHour)`
  padding: 0 15px;
  background-color: var(--primary100);
  display: flex !important;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.background-error {
    background-color: var(--error100);
  }
  .field {
    &.time-input {
      width: 38px;
    }

    &.date-input {
      width: 50px;
      margin-left: 5px;
    }
    & > input {
      height: 100%;
      border: solid 0px white;
      padding: 0.4rem 0.4rem;
      outline: none;
    }
  }
`;
